module.exports = __webpack_public_path__ + "h5/img/f6.273cd825.jpg";